<template>
	<div id="MAM_terminalList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="formInline.phone" placeholder="请输入代理商账号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.real_name" placeholder="请输入代理商名称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="formInline.group_name" placeholder="请输入活动名称"></el-input>
                </el-form-item>
				<el-form-item>
					<el-select :editable="false" size="medium" v-model="formInline.status" filterable clearable style="width:100%"
						placeholder="请选择达标情况">
						<el-option label="进行中" value="10"></el-option>
						<el-option label="已达标" value="20"></el-option>
						<el-option label="未达标" value="30"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="报名开始日期"
                        end-placeholder="报名结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(formInline)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-download" style="font-size: 12px;" @click="downLoad(formInline)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="transferList.list" size="mini" border style="width: 100%" v-loading="loading">
				<!-- 代理商名称 -->
				<el-table-column header-align="center" align="center" prop="real_name" label="代理商名称"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="phone" label="代理商账号"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="level" label="代理商层级" min-width="120"></el-table-column>
                <el-table-column header-align="center" align="center" prop="create_time" label="报名时间" min-width="160">
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="达标情况" min-width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 10" style="color: #E89E42;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 20" style="color: #81B437;">{{scope.row.status_text}}</span>
                        <span v-if="scope.row.status == 30" style="color: #C72A29;">{{scope.row.status_text}}</span>
					</template>
				</el-table-column>
                <el-table-column header-align="center" align="center" prop="group_name" label="活动名称" min-width="150">
                </el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize" style="text-align: center"></paginations>
		</el-card>
        
        <el-dialog title="下级代理达标明细" width="800px" :visible="isDetail"  @close="handleClose">
            <el-table :data="cellItem.month_data" size="mini" border style="width: 100%">
            	<!-- 代理商名称 -->
            	<el-table-column header-align="center" align="center" prop="nickname" label="代理商名称"
            		min-width="150"></el-table-column>
            	<el-table-column header-align="center" align="center" prop="phone" label="代理商账号"
            		min-width="150"></el-table-column>
            	<el-table-column header-align="center" align="center" prop="cellItem.level_name" label="达标档位" min-width="150">
                    <template slot-scope="scope">
                        <span>{{cellItem.level_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="cumulative_money" label="考核月交易量（万元）"
                	min-width="150"></el-table-column>
            	<el-table-column header-align="center" align="center" prop="qualify_time" label="完成考核时间"
            		min-width="150"></el-table-column>
            </el-table>
        	
        </el-dialog>
	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "downSalaryAwardFinishList",
		data() {
			return {
				tableTitle: {
					total: 0, //总设备数
					total_bind: 0, //总绑定数
					total_active: 0, //总激活数
				},
				brandList: [],
				formInline: {
					real_name: '', //代理商名字
					phone: '', //代理商账号
                    date:'', // 达标月份
                    status:'' ,// 达标情况
                    start_time:'',
                    end_time:'',
                    group_name:''
				},
				transferList: {
					list: [],
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0 //总数
				},
				loading: true,
                mainItem:{},
                isDetail:false,
                cellItem:{},
                rangeDate:[],
			}
		},
		mounted() {
			this.getData()
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.formInline.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.formInline.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            handleClose() {
            	this.isDetail = false;
            },
            detailClick(item){
                this.cellItem = item
                this.isDetail = true
            },
			onSearch() { //搜索
				this.page.currentPage = 1;
				// 表单提交
				this.getData()
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.getData();
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.getData()
			},
			getData() {
                this.formInline.page = this.page.currentPage
                this.formInline.limit = this.page.pageSize
				this.$api.post("user_dividends/signUpList", this.formInline, res => {
					let data = res.data;
					this.page.total = data.total; //总数
					this.transferList.list = res.data.data;
                    this.mainItem = data
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			downLoad(formInline) { //导出
				let reqData = {
					type: 25,
					value: JSON.stringify(formInline)
				};

				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}

				})
			}
		}
	};
</script>





<style lang="scss" scope>
	.el-input__inner {
		font-size: 12px;
	}

	.el-form-item {
		margin-bottom: 5px;
	}

	.el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}

	.el-popover__title {
		font-size: 12px;
		font-weight: 700;
	}

	.MAM_terminalList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}

		.tableTitle {
			display: inline-block;
			margin-right: 20px;
		}
	}

	.terminal_operate {
		display: flex;
	}

	.el-button {
		font-size: 12px !important;
	}
</style>